import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { set } from "lodash";
const baseURL = process.env.REACT_APP_SERVER_URL;

const UserRating = () => {
  const [phoneInput, setPhoneInput] = useState("");
  const [phoneList, setPhoneList] = useState([]);
  const [rating, setRating] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRating = async () => {
    try {
      const response = await axios.get(`${baseURL}/tnibroadmin/rating-trigger`);
      setRating(response.data.response);
    } catch (error) {
      toast.error("Error fetching rating data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRating();
  }, []);

  const handleAddPhone = () => {
    const inputs = phoneInput
      .split(/[\s,]+/)
      .map((num) => num.trim())
      .filter((num) => num.length > 0);

    const validPhones = [];
    const invalidPhones = [];

    inputs.forEach((num) => {
      if (!/^\d{10}$/.test(num)) {
        invalidPhones.push(num);
      } else if (!phoneList.includes(num) && !validPhones.includes(num)) {
        validPhones.push(num);
      }
    });

    if (invalidPhones.length > 0) {
      toast.warning(`Invalid phones: ${invalidPhones.join(", ")}`);
    }

    if (validPhones.length === 0) {
      return;
    }

    setPhoneList([...phoneList, ...validPhones]);
    setPhoneInput("");
  };
  const handleRemovePhone = (phone) => {
    setPhoneList(phoneList.filter((p) => p !== phone));
  };
  const handleSubmit = async () => {
    if (phoneList.length === 0) {
      toast.error("Please add at least one phone number.");
      return;
    }
    try {
      const response = await axios.post(
        `${baseURL}/tnibroadmin/rating-trigger`,
        { phones: phoneList }
      );
      toast.success("Rating trigger sent successfully!");
      setPhoneList([]);
      fetchRating();
    } catch (error) {
      const errMsg = error?.response?.data?.error || "Something went wrong.";
      toast.error(errMsg);
    }
  };
  return (
    <>
      <Box p={4}>
        <Typography variant="h4">User Rating</Typography>
        <Box mt={2}>
          <FormControl sx={{ mb: 2, width: "100%", maxWidth: 400 }}>
            <TextField
              label="Enter Phone Number"
              value={phoneInput}
              onChange={(e) => setPhoneInput(e.target.value)}
            />
          </FormControl>
          <IconButton
            onClick={handleAddPhone}
            color="success"
            sx={{ height: 56 }}
          >
            <AddCircleOutlineIcon fontSize="large" />
          </IconButton>
        </Box>
        {/* Phone List */}
        <List sx={{ maxWidth: 400, mt: 2 }}>
          {phoneList.map((phone, index) => (
            <ListItem key={index} divider>
              <ListItemText primary={phone} />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  color="error"
                  onClick={() => handleRemovePhone(phone)}
                >
                  <RemoveCircleOutlineIcon fontSize="large" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          sx={{ mt: 3 }}
        >
          Submit
        </Button>
        {/* Table View */}
        <Box mt={6}>
          <Typography variant="h5" gutterBottom>
            Rating Trigger History
          </Typography>
          {loading ? (
            <CircularProgress />
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>User</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Phone No.</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Sent At</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Seen</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Seen At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rating &&
                    rating?.map((row) => (
                      <TableRow key={row?.id}>
                        <TableCell>{row?.id}</TableCell>
                        <TableCell>{row.user}</TableCell>
                        <TableCell>{row.phoneno}</TableCell>
                        <TableCell>
                          {new Date(row.sent_at).toLocaleString()}
                        </TableCell>
                        <TableCell>{row.seen ? "Yes" : "No"}</TableCell>
                        <TableCell>
                          {row.seen_at
                            ? new Date(row.seen_at).toLocaleString()
                            : "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UserRating;
